module.exports = __webpack_public_path__ + "static/media/ic-medicine-heart-hear.cd027873.svg";